import {useMergedPath} from '../../shared-deprecated/useMergedPath';
import {FIRST_PRODUCT_ID_PARAM} from '../firstProductId/useFirstProductIds';
import {ExtendedCategoryItem} from './CategorySlider';

export const useNormalizedCategories = (
  activeCategoryId?: number,
  categories?: Array<ExtendedCategoryItem>,
): Array<{
  active: boolean;
  disabled: boolean;
  id: number;
  saleBadge?: {color: string};
  label: string;
  target: string;
  overrideTarget?: string;
}> => {
  const getMergedPath = useMergedPath();

  if (!categories) {
    return [];
  }

  return categories.map(category => {
    const currentCategory = category.category;

    const active = currentCategory.id === activeCategoryId;
    const disabled = !category.hasProducts;
    const label = currentCategory.name;
    const saleBadge = category.badge?.saleBadge;
    const target = category.targetPath
      ? currentCategory.path
      : getMergedPath({
          path: currentCategory.path,
          config: {excludeUrlParams: new Set([FIRST_PRODUCT_ID_PARAM])},
        });
    const overrideTarget =
      category.targetPath &&
      getMergedPath({
        path: category.targetPath,
        config: {excludeUrlParams: new Set([FIRST_PRODUCT_ID_PARAM])},
      });

    return {
      active,
      disabled,
      id: currentCategory.id,
      label,
      saleBadge,
      target,
      overrideTarget,
    };
  });
};
